import { useLayoutEffect, useState } from "react";
import { MOBILE_BREAKPOINT } from "shared/constants/common.constants";
import { useDebounce } from "shared/hooks/useDebounce.hook";
import { useResize } from "shared/hooks/useResize.hook";
import { AppDOM } from "shared/utils/app.utils";

type useMobileReturnType = {
  isMobile: boolean;
};

type UseWindowSizeParams = {
  debounceTime?: number;
};

export const useMobile = ({ debounceTime = 100 }: Partial<UseWindowSizeParams> = {}): useMobileReturnType => {
  const { debounce } = useDebounce(debounceTime);

  const [isMobile, setIsMobile] = useState(false);

  const persistWindowSize = () => {
    setIsMobile(AppDOM.appContainer.clientWidth <= MOBILE_BREAKPOINT);
  };

  useLayoutEffect(() => {
    persistWindowSize();
  }, []);

  useResize(() => {
    if (typeof debounceTime !== "undefined") {
      debounce(() => {
        persistWindowSize();
      });
      return;
    }
    persistWindowSize();
  });

  return { isMobile };
};
